export default __webpack_public_path__ + "static/media/Seminar.49e2d381.webp";